import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import PolizasPage from "./pages/PolizasPage";
import ResumenPage from "./pages/ResumenPage";
import HistorialPage from "./pages/HistorialPage";
import SessionExpiredPage from "./pages/SessionExpiredPage";
import { ProtectedRoute } from "./components/protected-route";

function App() {
  const baseUrl = import.meta.env.BASE_URL;

  return (
    <Routes>
      <Route path={`${baseUrl}/login`} element={<LoginPage />} />
      <Route
        path={`${baseUrl}/sesion-expirada`}
        element={<SessionExpiredPage />}
      />

      <Route
        path={`${baseUrl}/polizas`}
        element={
          <ProtectedRoute>
            <PolizasPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${baseUrl}/`}
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        }
      />

      <Route
        path={`${baseUrl}/resumen`}
        element={
          <ProtectedRoute>
            <ResumenPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${baseUrl}/historial`}
        element={
          <ProtectedRoute>
            <HistorialPage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to={`/`} replace />} />
    </Routes>
  );
}

export default App;
